import { useEffect, useState } from "react";
import classNames from "classnames";
import Image from "next/image";

import styles from "./AscResourcesBanner.module.scss";
import { ColorVariants } from "../../lib/models";
import FirstBackground from "./backgrounds/FirstBackground";
import SecondBackground from "./backgrounds/SecondBackground";
import ThirdBackground from "./backgrounds/ThirdBackground";
import FourthBackground from "./backgrounds/FourthBackground";
import FifthBackground from "./backgrounds/FifthBackground";
import SixthBackground from "./backgrounds/SixthBackground";
import {  AscImage } from '@ascendnow/ascend-components';

export interface AscResourcesBannerProps {
  className?: string;
  color: ColorVariants;
  variant: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  face?: "woman-1" | "woman-2" | "man-1" | "man-2" | "man-3";
  text: string;
  secondText?: string;
}

export default function AscResourcesBanner({
  className,
  variant = 1,
  color = "TEAL",
  face,
  text,
  secondText,
}: AscResourcesBannerProps) {
  const [background, setBackground] = useState<JSX.Element>();
  const [faceVariant, setFaceVariant] = useState<string>("center");

  useEffect(() => {
    switch (variant) {
      case 1:
        setBackground(
          <FirstBackground color={color} className={styles.background} />
        );
        setFaceVariant("center");
        break;

      case 2:
        setBackground(
          <SecondBackground color={color} className={styles.background} />
        );
        setFaceVariant("left");
        break;

      case 3:
        setBackground(
          <ThirdBackground color={color} className={styles.background} />
        );
        setFaceVariant("right");
        break;

      case 4:
        setBackground(
          <FourthBackground color={color} className={styles.background} />
        );
        setFaceVariant("left-big");
        break;

      case 5:
        setBackground(
          <FifthBackground color={color} className={styles.background} />
        );
        setFaceVariant("");
        break;

      case 6:
        setBackground(
          face ? (
            <SixthBackground color={color} className={styles.background} />
          ) : (
            <div className={classNames(styles.background, styles[color])} />
          )
        );
        setFaceVariant(face ? "right" : "");
        break;
      case 7:
        setBackground(
          <FifthBackground color={color} className={styles.background} />
        );
        setFaceVariant("");
        break;
    }
  }, [color, variant, face]);


  return (
    <div
      data-testid="asc-resources-banner"
      className={classNames(styles.ground, className)}
    >
      {background}
      {face && variant !== 5 && (
        <AscImage
          src={`/images/resources/${face}/${faceVariant}.png`}
          alt={`resources-banner-${face}-${faceVariant}`}
          className={classNames(styles.face, styles[faceVariant])}
        />
      )}

      <div
        className={classNames(styles.textWrapper, {
          [styles.big]: variant === 6 && face,
          [styles.medium]: variant === 2 || variant === 3,
          [styles.left]: variant === 3,
          [styles.right]: variant === 2,
          [styles.small]: variant === 4,
          [styles.two]: variant === 4,
          [styles.noImage]: variant === 5,
          [styles.full]: variant === 7 && !face,
        })}
      >
        <p
          className={classNames(styles.text, {
            [styles.big]: variant === 5,
            [styles.white]: variant === 6,
          })}
        >
          {text}
        </p>
      </div>

      {secondText && (
        <div
          className={classNames(styles.secondTextWrapper, {
            [styles.right]: variant === 4,
          })}
        >
          <p className={classNames(styles.text)}>{secondText}</p>
        </div>
      )}
    </div>
  );
}
